import React, { Component } from 'react';

import ApiLayersMap from '../../../../../../modules/WebApiModules/ApiLayersMap';
import { LayerContext } from '../../../../../../modules/ContextModules/LayoutContext';
import { LayoutContext } from '../../../../../../modules/ContextModules/LayoutContext';
import './Layer.css'

import layerImg from './.image/layer.png'

export class Layer extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props)

        this.state = {
            isOpened: false
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <li key={this.props.data.Name} className='treeItem'>
                <div className='layerHeader'>
                    <input type="checkbox"
                        onClick={(e) => { e.stopPropagation(); }}
                        onChange={(e) => { this.handleLayerOpen(e); }}
                        checked={this.isCheck()}
                    />
                    <div style={{lineHeight: '20px'}}>
                        <img src={layerImg} width={16} height={16} alt="圖層_圖示"/>
                    </div>                                         
                    <span>{this.props.data.Name}</span>
                </div>
            </li>
        );
    }

    isCheck() {
        const { selectedLayerContext } = this.context;
        for (const layer of selectedLayerContext.layers) {
            if (layer.Name === this.props.data.Name) {
                return true;
            }
        }
        return false;
    }

    handleLayerOpen = (event) => {
        // 開啟
        
        if (/*event.currentTarget.checked*/!this.isCheck() === true) {
            this.props.updateLayerList.addLayerToList(this.props.data/*{
                Name: this.props.name,
                Data: this.props.data,
                Class: this.props.class
            }*/);
            // ApiLayersMap.ListLayerInfo(
            //     { FolderFullName: this.props.data, Name: this.props.name },
            //     (result) => {
            //         console.log(result);
            //     },
            //     () => {
            //         console.error(`取得${this.props.data}/${this.props.name}圖層資訊失敗`)
            //     }
            // )
        } else {
            this.props.updateLayerList.removeLayerFromList(this.props.data/*{
                Name: this.props.name,
                Data: this.props.data,
                Class: this.props.class
            }*/);
        }
        // 關閉
        // 通知已選圖層
        
        event.stopPropagation();
    }
}